import React from 'react';
import type { WorkflowType } from '@this/domain/organization/organization2';
import DomesticHotelSection from '@this/components/organization/setting/workflow_setting_section/domestic_hotel_section';
import ForeignHotelSection from '@this/components/organization/setting/workflow_setting_section/foreign_hotel_section';
import DomesticFlightSection from '@this/components/organization/setting/workflow_setting_section/domestic_flight_section';
import PackageSection from '@this/components/organization/setting/workflow_setting_section/package_section';

const styles = {
  container: {
    padding: '16px',
    background: '#ffffff',
    borderRadius: '8px'
  }
};

interface WorkflowSettingSectionProps {
  domesticHotelUnderRegulationWorkflowType: WorkflowType;
  domesticHotelUnderRegulationBufferAmount: number;
  domesticHotelOverRegulationWorkflowType: WorkflowType;
  domesticHotelOverRegulationBufferAmount: number;
  foreignHotelUnderRegulationWorkflowType: WorkflowType;
  foreignHotelUnderRegulationBufferAmount: number;
  foreignHotelOverRegulationWorkflowType: WorkflowType;
  foreignHotelOverRegulationBufferAmount: number;
  domesticFlightWorkflowType: WorkflowType;
  domesticFlightBufferAmount: number;
  packageWorkflowType: WorkflowType;
  packageBufferAmount: number;
  handleChangeWorkflowType: (type: WorkflowType, target: string) => void;
  handleChangeBufferAmount: (amount: number, target: string) => void;
}

const WorkflowSettingSection: React.FC<WorkflowSettingSectionProps> = ({
  domesticHotelUnderRegulationWorkflowType,
  domesticHotelUnderRegulationBufferAmount,
  domesticHotelOverRegulationWorkflowType,
  domesticHotelOverRegulationBufferAmount,
  foreignHotelUnderRegulationWorkflowType,
  foreignHotelUnderRegulationBufferAmount,
  foreignHotelOverRegulationWorkflowType,
  foreignHotelOverRegulationBufferAmount,
  domesticFlightWorkflowType,
  domesticFlightBufferAmount,
  packageWorkflowType,
  packageBufferAmount,
  handleChangeWorkflowType,
  handleChangeBufferAmount
}) => {
  return (
    <div style={styles.container}>
      <DomesticHotelSection
        domesticHotelUnderRegulationWorkflowType={domesticHotelUnderRegulationWorkflowType}
        domesticHotelUnderRegulationBufferAmount={domesticHotelUnderRegulationBufferAmount}
        domesticHotelOverRegulationWorkflowType={domesticHotelOverRegulationWorkflowType}
        domesticHotelOverRegulationBufferAmount={domesticHotelOverRegulationBufferAmount}
        handleChangeWorkflowType={handleChangeWorkflowType}
        handleChangeBufferAmount={handleChangeBufferAmount}
      />

      <ForeignHotelSection
        foreignHotelUnderRegulationWorkflowType={foreignHotelUnderRegulationWorkflowType}
        foreignHotelUnderRegulationBufferAmount={foreignHotelUnderRegulationBufferAmount}
        foreignHotelOverRegulationWorkflowType={foreignHotelOverRegulationWorkflowType}
        foreignHotelOverRegulationBufferAmount={foreignHotelOverRegulationBufferAmount}
        handleChangeWorkflowType={handleChangeWorkflowType}
        handleChangeBufferAmount={handleChangeBufferAmount}
      />

      <DomesticFlightSection
        domesticFlightWorkflowType={domesticFlightWorkflowType}
        domesticFlightBufferAmount={domesticFlightBufferAmount}
        handleChangeWorkflowType={handleChangeWorkflowType}
        handleChangeBufferAmount={handleChangeBufferAmount}
      />

      <PackageSection
        packageWorkflowType={packageWorkflowType}
        packageBufferAmount={packageBufferAmount}
        handleChangeWorkflowType={handleChangeWorkflowType}
        handleChangeBufferAmount={handleChangeBufferAmount}
      />
    </div>
  );
};

export default WorkflowSettingSection;
